import React from 'react';

export function SpanWithHtml({ label, className }: { label: string; className?: string }) {
	return <span className={className} dangerouslySetInnerHTML={{ __html: label }} />;
}
